import React from "react";
import {
    createStyles,
    Grid,
    Theme,
    Typography,
    withStyles,
    WithStyles
} from "@material-ui/core";

type SectionBannerProps = WithStyles<typeof styles> & {
    leftSideComponent?: JSX.Element;
    leftSideText?: string;
    rightSideComponent?: JSX.Element;
};

const styles = (theme: Theme) =>
    createStyles({
        banner: {
            [theme.breakpoints.down("xs")]: {
                paddingLeft: theme.bodyContent.mobilePadding,
                paddingRight: theme.bodyContent.mobilePadding
            },
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            paddingLeft: theme.bodyContent.desktopPadding,
            paddingRight: theme.bodyContent.desktopPadding,
            width: "100%"
        },
        bannerContent: {
            [theme.breakpoints.down("sm")]: {
                paddingBottom: theme.spacing(2),
                paddingTop: theme.spacing(2)
            },
            margin: "0 auto",
            maxWidth: theme.bodyContent.maxWidth,
            width: "100%"
        },
        height: {
            [theme.breakpoints.down("sm")]: { height: 160 },
            height: 100
        },
        heightLeftOnly: { height: 100 },
        leftSideComponent: {
            [theme.breakpoints.down("sm")]: { textAlign: "center" },
            display: "flex"
        },
        leftSideText: {
            [theme.breakpoints.down("xs")]: { fontSize: 28 },
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
        },
        rightSideComponent: {
            [theme.breakpoints.down("sm")]: { justifyContent: "center" },
            display: "flex",
            justifyContent: "flex-end"
        }
    });

class SectionBanner extends React.PureComponent<SectionBannerProps, {}> {
    public render() {
        const classes = this.props.classes;

        const rootClass = this.props.rightSideComponent
            ? `${classes.banner} ${classes.height}`
            : `${classes.banner} ${classes.heightLeftOnly}`;

        const containerClass = this.props.rightSideComponent
            ? `${classes.bannerContent} ${classes.height}`
            : `${classes.bannerContent} ${classes.heightLeftOnly}`;
        return (
            <div className={rootClass}>
                <Grid
                    className={containerClass}
                    container={true}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Grid
                        className={classes.leftSideComponent}
                        item={true}
                        xs={12}
                        sm={12}
                        md={6}
                    >
                        {this.props.leftSideText && (
                            <Typography
                                component="h1"
                                variant="h4"
                                className={classes.leftSideText}
                            >
                                {this.props.leftSideText}
                            </Typography>
                        )}

                        {this.props.leftSideComponent}
                    </Grid>
                    {this.props.rightSideComponent && (
                        <Grid
                            className={classes.rightSideComponent}
                            item={true}
                            xs={12}
                            sm={12}
                            md={6}
                        >
                            {this.props.rightSideComponent}
                        </Grid>
                    )}
                </Grid>
            </div>
        );
    }
}

export default withStyles(styles)(SectionBanner);
